import equal from 'deep-equal';
import { last } from 'lodash';

export default function compareRangeLists(t1, t2) {
  if (!t1 !== !t2) return false;
  if (Array.isArray(t1) && Array.isArray(t2)) {
    if (t1.length !== t2.length) return false;
    return equal(last(t1), last(t2));
  }
  return equal(t1, t2);
}
